import { gql } from '@apollo/client';

const GET_AGGREGATE_PERFORMANCE_REPORT = gql`
  query GetAggregatePerformanceReport {
    aggregatePerformanceReport {
      Classification {
        Id
        ClassificationMeasurementName
      }
      MeasurementUnit
      MeasurementCalculationName
      GoodPerformanceIndicator
      NumberOfSites
      ExpirationData {
        Year
        Quarter
      }
      QuarterlyData {
        Quarter {
          Year
          QuarterNum
          DisplayName
        }
        Average
        Median
        Count
      }
    }
  }
`;

export default GET_AGGREGATE_PERFORMANCE_REPORT;
